var map = {
	"./pitch_black.png": 83276,
	"./pitch_black_HQ.png": 12048,
	"./pitch_black_old.png": 91354,
	"./pitch_black_wide.png": 69768,
	"./pitch_blue.png": 70277,
	"./pitch_blue_HQ.png": 62527,
	"./pitch_blue_old.png": 23059,
	"./pitch_blue_vertical.png": 83520,
	"./pitch_blue_wide.png": 24395,
	"./pitch_green.png": 60380,
	"./pitch_green_HQ.png": 7328,
	"./pitch_green_old.png": 57610,
	"./pitch_green_vertical.png": 37375,
	"./pitch_green_wide.png": 62008,
	"./pitch_grey.png": 89900,
	"./pitch_grey_wide.png": 88584,
	"./pitch_white.png": 47222,
	"./pitch_white_old.png": 60036,
	"./pitch_white_wide.png": 50686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34083;